import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { ITogglePanelProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<ITogglePanelProps>>
): IComponentSchema<ITogglePanelProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.TogglePanel,
    'x-component-props': {
      tab: props?.['x-component-props']?.tab || 'New Panel',
      defaultVisible:
        props?.['x-component-props']?.defaultVisible !== undefined
          ? props['x-component-props']!.defaultVisible
          : true,
      ...props?.['x-component-props'],
    },
    'x-component-props-config': {},
    properties: props?.properties || {},
  };
};
